
    <div class="notice" *ngIf="available > 0 && !hasEnabled">
      <div class="icon"><i class="fal fa-gift"></i></div>
      <div class="text">Don't miss your chance! Before depositing, activate your <strong>Welcome Package</strong>!</div>
      <a href="/account/bonus" class="button" (click)="openBonuses($event)">Show my bonuses</a>
    </div>
    <div class="notice" *ngIf="available > 0 && hasEnabled && enabled">
      <div class="icon"><i class="fal fa-gift"></i></div>
      <div class="text">{{ enabled.description }}</div>
      <a href="/account/bonus" class="button" (click)="openBonuses($event)">Show my bonuses</a>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/deposit-bonus.component.ts.DepositBonusComponent.html